import { EntityType } from 'packages/store/sharing/types';
import { gatewayClient, createService } from './connectors/httpClient';

const httpClient = gatewayClient('/access-control');

const accessControlService = createService(httpClient, (client) => ({
    updateAccess(data) {
        return client.put('', data);
    },

    updateOwnership(data) {
        return client.put<{ message: string }>('/change-owner', data);
    },

    getAccess(entityId: number[], entityType: EntityType) {
        return client.get(`/entities/permissions-list?entityType=${entityType}&entityIds=${entityId[0]}`);
    },
}));

export default accessControlService;
